/**
 * Adds a specified number of days to a date
 * Uses date-only arithmetic to avoid timezone issues
 */
export const addDaysToDate = (startDate: Date, numDays: number): Date => {
  const result = new Date(
    startDate.getFullYear(),
    startDate.getMonth(),
    startDate.getDate()
  )
  result.setDate(result.getDate() + numDays)
  return result
}

/**
 * Gets the weekday name for a date offset from a start date
 */
export const getWeekdayName = (startDate: Date, dayOffset: number): string => {
  const forDate = addDaysToDate(startDate, dayOffset)
  return forDate.toLocaleString('en', { weekday: 'long' })
}

/**
 * Creates an array of day indices for iteration
 */
export const createDayIndicesArray = (numOfDays: number): number[] => {
  const dayItems: number[] = []
  for (let i = 0; i < numOfDays; i++) {
    dayItems.push(i)
  }
  return dayItems
}

/**
 * Checks if a given weekday name represents a weekend
 */
export const isWeekendDay = (weekdayName: string): boolean => {
  return weekdayName === 'Sunday' || weekdayName === 'Saturday'
}

/**
 * Gets the current or previous Sunday from a given date
 * If the date is already Sunday, returns that date
 */
export const getPreviousOrCurrentSunday = (date: Date): Date => {
  const result = new Date(date.getFullYear(), date.getMonth(), date.getDate())
  const dayOfWeek = result.getDay() // 0 = Sunday, 1 = Monday, etc.
  result.setDate(result.getDate() - dayOfWeek)
  return result
}

/**
 * Gets the Sunday before or on the first day of the month containing the given date
 */
export const getSundayBeforeMonthStart = (date: Date): Date => {
  const firstOfMonth = new Date(date.getFullYear(), date.getMonth(), 1)
  return getPreviousOrCurrentSunday(firstOfMonth)
}
